import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsAppButton = () => {
  const whatsappUrl = "https://web.whatsapp.com/send?phone=918977626223&text=Hello!%20splash";
  
  // Fallback for mobile devices to use the app instead of web
  const mobileWhatsappUrl = "https://wa.me/918977626223?text=Hello!%20splash";

  const handleClick = () => {
    const url = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      ? mobileWhatsappUrl
      : whatsappUrl;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Tooltip title="Chat on WhatsApp" placement="left">
      <Fab
        color="success"
        aria-label="whatsapp"
        onClick={handleClick}
        sx={{
          position: 'fixed',
          bottom: 24,
          right: 24,
          backgroundColor: '#25D366',
          '&:hover': {
            backgroundColor: '#128C7E',
          },
          zIndex: 1000,
        }}
      >
        <WhatsAppIcon />
      </Fab>
    </Tooltip>
  );
};

export default WhatsAppButton;